import React from 'react';

const OurStory = ({ lang }) => {
  const isRtl = lang === 'ar';

  return (
    <section id="our-story" className="story-premium-section" style={{ direction: isRtl ? 'rtl' : 'ltr' }}>
      <div className="story-content-container">
        
        {/* عنوان جانبي رفيع لإضفاء لمسة احترافية */}
        <div className="story-side-label">
          <span>{isRtl ? 'قصة  يام إنترناشونال' : 'Story YAM International'}</span>
        </div>

        <div className="story-main-text-wrapper">
          <h2 className="story-title-minimal">{isRtl ? 'قصتنا' : 'Our Story'}</h2>
          
          <div className="story-text-block">
            {isRtl ? (
              <>
                بدأت شركة <span className="gold-highlight">يام إنترناشونال للصناعات</span> رحلتها عام 2018 كجزء من مجموعة عالمية تؤمن بالابتكار والتطوير المستمر. 
                خلال سنوات قليلة، تمكّنا من ترسيخ حضورنا في قطاع المنظفات والصناعات الكيميائية، مدفوعين برؤية طموحة وفهم عميق لاحتياجات السوق. 
                واليوم، من خلال مصنعنا المتطور في <span className="gold-highlight">مدينة بدر</span>، نعتز بتقديم منتجات عالية الجودة صُممت بعناية لتكون متميزة في فئتها، 
                ملتزمين بتوفير حلول آمنة وصحية تضمن الفعالية القصوى مع الحفاظ على سلامة عملائنا، لنواصل رحلتنا بثقة نحو الريادة والابتكار في الأسواق العربية.
              </>
            ) : (
              <>
                <span className="gold-highlight">YAM International Industries</span> began its journey in 2018, driven by innovation and excellence. 
                Within a few years, we established a strong presence in the chemical industry through our state-of-the-art facility in <span className="gold-highlight">Badr City</span>. 
                We take pride in delivering high-quality, safe, and effective solutions, striving to be the first choice for those seeking quality and innovation across the region.
              </>
            )}
          </div>
        </div>
      </div>

      <style>{`
        .story-premium-section {
          padding: 150px 0 !important;
          background-color: #ffffff !important;
          position: relative;
          overflow: hidden;
        }

        .story-content-container {
          width: 85% !important;
          max-width: 1100px !important;
          margin: 0 auto !important;
          display: flex;
          gap: 60px;
          align-items: flex-start;
        }

        .story-side-label {
          writing-mode: vertical-rl;
          transform: rotate(180deg);
          color: #d4af37;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 5px;
          font-size: 0.9rem;
          opacity: 0.6;
          border-left: ${isRtl ? 'none' : '1px solid #d4af37'} !important;
          border-right: ${isRtl ? '1px solid #d4af37' : 'none'} !important;
          padding: 20px 10px;
        }

        .story-main-text-wrapper {
          flex: 1;
        }

        .story-title-minimal {
          font-size: 4rem !important;
          font-weight: 900 !important;
          color: #1a3a5a !important;
          margin-bottom: 40px !important;
          line-height: 1 !important;
        }

        .story-text-block {
          font-size: 1.8rem !important;
          line-height: 1.7 !important;
          color: #334155 !important;
          font-weight: 600 !important;
          text-align: justify !important;
          max-width: 900px;
        }

        .gold-highlight {
          color: #d4af37 !important;
          font-weight: 800 !important;
        }

        /* لمسة جمالية خلفية (اختيارية) */
        .story-premium-section::before {
          content: "YAM";
          position: absolute;
          top: -50px;
          right: -50px;
          font-size: 20rem;
          font-weight: 900;
          color: rgba(0,0,0,0.02);
          z-index: 0;
        }

        @media (max-width: 991px) {
          .story-content-container { flex-direction: column; gap: 30px; }
          .story-side-label { writing-mode: horizontal-tb; transform: none; border: none !important; border-bottom: 2px solid #d4af37 !important; padding: 0 0 10px 0; }
          .story-title-minimal { font-size: 3rem !important; }
          .story-text-block { font-size: 1.4rem !important; }
        }
      `}</style>
    </section>
  );
};

export default OurStory;